import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const ITR_saveBsDocUpload_API_CALL = createAsyncThunk(
  'ITR_saveBsDocUpload_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'ITR_saveBsDocUpload_API_CALL/pending', payload: {} });
    const { saveBsDocUploadPayload, successFn, errorFn, finallyFn } = payload;
    const {
      customerId,
      customerRefNum,
      Authorization,
      filePath,
      proofId,
      methodType,
      requestType,
      journeyType,
      password,
    } = saveBsDocUploadPayload;
    const { itrPassword } = getState().itrJourney;
    console.log({ store: getState().itrJourney });
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'customerkyc/savedocumentdetails',
      payload: {
        proofId: 131,
        requestType: 'SAVE_ITR',
        filePath: [...filePath],
        customerRefNum,
        password: itrPassword,
        journeyType: getState().itrJourney.journeyTypeEnum,
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const saveBsDocuploadResponse = res;
        dispatch({
          type: 'ITR_saveBsDocUpload_API_CALL/fulfilled',
          payload: saveBsDocuploadResponse,
        });
        if (successFn) successFn(saveBsDocuploadResponse);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'ITR_saveBsDocUpload_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const ITR_saveBsDocUpload_API_CALL_extrareducer = {
  [ITR_saveBsDocUpload_API_CALL.pending]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = true;
  },
  [ITR_saveBsDocUpload_API_CALL.fulfilled]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = false;

    state.saveBsDocUploadAPICall.isSuccess = true;
    state.saveBsDocUploadAPICall.isError = false;
    state.saveBsDocUploadAPICall.response = action.payload;
  },
  [ITR_saveBsDocUpload_API_CALL.rejected]: (state, action) => {
    state.saveBsDocUploadAPICall.isLoading = false;

    state.saveBsDocUploadAPICall.isSuccess = false;
    state.saveBsDocUploadAPICall.isError = true;
    state.saveBsDocUploadAPICall.response = action.payload;
  },
};
